import { handleResponse, handleError } from './api-utils';

export function loadAnalyticsAppData(callbackUrl) {
    return fetch(callbackUrl, {
        method: 'GET',
        headers: { 'content-type': 'application/json' }
    })
        .then(handleResponse)
        .catch(handleError);
}
